'use strict';

import React from 'react';
import { isEmpty } from 'lodash';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import Alert from '../../components/Alert';
import { FormattedMessage } from 'react-intl';
import {
  approveTimelineEvent,
  setReferralNotified,
  showRescheduleTransitionModal,
  togglePastEvents,
  showMorePastEvents,
  navigateToReschedule,
} from './data/actions';
import TimelineRescheduleTransitionModal from './components/TimelineRescheduleTransitionModal';
import {
  selectNotificationData,
  selectUpcomingAndPastEvents,
  showPlaceHolderOnTimeline,
} from './data/selector';
import {QUESTIONNAIRES, TIMELINE, TIMELINEFRAME} from '../../data/reducer';

import Row from '../../components/tag/Row';
import Span from '../../components/tag/Span';
import ApprovedEvents from './components/ApprovedEvents';
import EventNotifications from './components/EventNotifications';
import TimelineTopAlert from './components/TimelineTopAlert';
import { getTime } from '../../utils/TimeUtils';
import { linkkipalveluSelector } from '../../data/selector';
import { FEATURE_FIMLAB, isFeatureOn } from '../../definitions/Config';

var moment = require('moment');

const { id: module_id } = module;

class Timeline extends React.Component {
  constructor() {
    super();
    this.state = {
      selection: 'upcoming',
    };
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
  }

  sortByDateDesc = (a, b) => {
    return this.sortByDate(a, b, 1);
  };

  sortByDateAsc = (a, b) => {
    return this.sortByDate(a, b, -1);
  };

  sortByDate = (a, b, direction) => {
    return getTime(a.date).isBefore(getTime(b.date))
      ? direction
      : direction * -1;
  };

  //check whether user is allowed to reschedule given appointment
  appointmentCanBeRescheduled = (appointment) => {
    return appointment.modify === 'CAN_RESCHEDULE';
  };

  handleDropdownChange(event) {
    this.setState({ selection: event.target.value });
  }

  handleEventList = (data) => {
    if (isEmpty(data)) {
      return data;
    }
    if (!isEmpty(data[0])) {
      let events = data[0].map((item) => {
        if (item.length > 1) {
          let subItems = item.map((subItem, index) => {
            switch (index) {
              case item.length - 1:
                return { ...subItem, index: 'last' };
              case 0:
                return { ...subItem, index: 'first' };
              default:
                return { ...subItem, index: 'middle' };
            }
          });
          return subItems;
        } else {
          return [{ ...item[0], index: 'only' }];
        }
      });
      return events;
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    let { navigateToTimelineFrame } = this.props;
    if (navigateToTimelineFrame) {
      this.props.history.replace(`/timeline/${navigateToTimelineFrame}`);
    }
  }

  render() {
    let {
      history,

      notifications,
      notificationsIsFetching,
      notificationsError,

      upcomingEvents,
      pastEvents,
      eventsError,
      eventsIsFetching,

      togglePastEvents,

      showPastEvents,
      pastEventsToRender,
      showMorePastEvents,
      showRescheduleTransitionModalForNotification,
      navigateToReschedule,

      approveTimelineEvent,
      setReferralNotified,
      showRescheduleTransitionModal,
      questIsFetching,

      linkkipalvelu,
      showPlaceholder,

      assignError,
    } = this.props;

    if (showPlaceholder) {
      return null;
    }

    let sameDayPastEvents = [];
    let sameDayUpcomingEvents = [];
    let regroupedPastEvents = [];
    let regroupedUpcomingEvents = [];

    regroupedPastEvents = pastEvents.map((timelineItem, index) => {
      if (!isEmpty(sameDayPastEvents)) {
        const date1 = moment(sameDayPastEvents[0].date).format('YYYY-MM-DD');
        const date2 = moment(timelineItem.date).format('YYYY-MM-DD');
        if (date1 === date2) {
          sameDayPastEvents.push(timelineItem);
        } else {
          regroupedPastEvents.push(sameDayPastEvents);
          sameDayPastEvents = [];
          sameDayPastEvents.push(timelineItem);
        }
      } else {
        sameDayPastEvents.push(timelineItem);
      }
      if (index === pastEvents.length - 1) {
        regroupedPastEvents.push(sameDayPastEvents);
      }
      return regroupedPastEvents;
    });

    regroupedUpcomingEvents = upcomingEvents.map((timelineItem, index) => {
      if (!isEmpty(sameDayUpcomingEvents)) {
        const date1 = moment(sameDayUpcomingEvents[0].date).format(
          'YYYY-MM-DD'
        );
        const date2 = moment(timelineItem.date).format('YYYY-MM-DD');
        if (date1 === date2) {
          sameDayUpcomingEvents.push(timelineItem);
        } else {
          regroupedUpcomingEvents.push(sameDayUpcomingEvents);
          sameDayUpcomingEvents = [];
          sameDayUpcomingEvents.push(timelineItem);
        }
      } else {
        sameDayUpcomingEvents.push(timelineItem);
      }
      if (index === upcomingEvents.length - 1) {
        regroupedUpcomingEvents.push(sameDayUpcomingEvents);
      }
      return regroupedUpcomingEvents;
    });

    let stateOfSelection = false;
    if (this.state.selection === 'upcoming') {
      stateOfSelection = true;
    }

    if (isFeatureOn(FEATURE_FIMLAB)) {
      if (eventsError.fimlabError && eventsError.timelineError) {
        return (
          <Alert
            className={'text-center'}
            type={'error'}
            message={`${module_id}.fetch.failed.error`}
          />
        );
      }
    } else {
      if (eventsError.timelineError) {
        return (
          <Alert
            className={'text-center'}
            type={'error'}
            message={`${module_id}.fetch.failed.error`}
          />
        );
      }
    }

    return (
      <>
        <Row className="ot-timeline-select-title-row">
          {stateOfSelection ? (
            <Span len="6" sm-len="12">
              <h1 className="ot-viewtitle">
                <FormattedMessage id="navigation.timeline" />
              </h1>
            </Span>
          ) : (
            <Span len="6" sm-len="12">
              <h1 className="ot-viewtitle">
                <FormattedMessage id="past.treatments" />
              </h1>
            </Span>
          )}

          <Span len="6" sm-len="12" className="ot-timeline-select">
            <select
              className="ot-timeline-select__dropdown"
              onChange={this.handleDropdownChange}
            >
              <option value="upcoming">Tulevat tapahtumat</option>
              <option value="past">Menneet tapahtumat</option>
            </select>
            <div className="ot-timeline-select__label">
              <FormattedMessage id="show" />
            </div>
          </Span>
        </Row>
        <TimelineTopAlert />
        {isFeatureOn(FEATURE_FIMLAB) && eventsError.fimlabError && (
          <Alert
            className={'text-center'}
            type={'error'}
            isHtml
            message={`${module_id}.fimlab.failed.error`}
          />
        )}
        {eventsError.timelineError && (
          <Alert
            className={'text-center'}
            type={'error'}
            isHtml
            message={`${module_id}.timeline.failed.error`}
          />
        )}
        {assignError !== null && (
          <Alert
            className={'text-center'}
            type={'error'}
            isHtml
            message={`${module_id}.assign.failed.error`}
          />
        )}

        {stateOfSelection ? (
          <EventNotifications
            notifications={notifications}
            qIsFetching={questIsFetching}
            isFetching={notificationsIsFetching}
            showRescheduleTransitionModal={showRescheduleTransitionModal}
            approveTimelineEvent={approveTimelineEvent}
            setReferralNotified={setReferralNotified}
            navigateToReschedule={navigateToReschedule}
            history={history}
            linkkipalvelu={linkkipalvelu}
          />
        ) : (
          <></>
        )}
        <ApprovedEvents
          selection={this.state.selection}
          questIsFetching={questIsFetching}
          showRescheduleTransitionModal={showRescheduleTransitionModal}
          pastEvents={this.handleEventList(regroupedPastEvents)}
          upcomingEvents={this.handleEventList(regroupedUpcomingEvents)}
          isFetching={eventsIsFetching}
          showPastEvents={showPastEvents}
          showMorePastEvents={showMorePastEvents}
          pastEventsToRender={pastEventsToRender}
          togglePastEvents={togglePastEvents}
          navigateToReschedule={navigateToReschedule}
          history={history}
          linkkipalvelu={linkkipalvelu}
        />
        <TimelineRescheduleTransitionModal
          isOpen={showRescheduleTransitionModalForNotification !== false}
          notificationId={showRescheduleTransitionModalForNotification}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  let {
    showPastEvents,
    showRescheduleTransitionModalForNotification,
    pastEventsToRender,
  } = state[TIMELINE];
  let {
    upcomingEvents,
    pastEvents,
    isFetching: eventsIsFetching,
    error: eventsError,
  } = selectUpcomingAndPastEvents(state);
  let {
    notifications,
    isFetching: notificationsIsFetching,
    error: notificationsError,
  } = selectNotificationData(state);
  let questIsFetching = state[QUESTIONNAIRES].isFetching;
  let linkkipalvelu = linkkipalveluSelector(state);
  let showPlaceholder = showPlaceHolderOnTimeline(state);
  let assignError = state[TIMELINE].assignError;
  let {
    timelineEventId
  } = state[TIMELINEFRAME];

  // console.log(assignError);
  return {
    notifications,
    notificationsIsFetching,
    notificationsError,

    upcomingEvents,
    pastEvents,
    eventsIsFetching,
    eventsError,

    showPastEvents,
    pastEventsToRender,

    showRescheduleTransitionModalForNotification:
      showRescheduleTransitionModalForNotification,
    questIsFetching,

    linkkipalvelu,
    showPlaceholder,

    assignError,
    navigateToTimelineFrame: timelineEventId
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    togglePastEvents: () => dispatch(togglePastEvents()),
    approveTimelineEvent: (id) => dispatch(approveTimelineEvent(id)),
    setReferralNotified: (id) => dispatch(setReferralNotified(id)),
    showRescheduleTransitionModal: (id) =>
      dispatch(showRescheduleTransitionModal(id)),
    showMorePastEvents: () => dispatch(showMorePastEvents()),
    navigateToReschedule: (id, history) =>
      dispatch(navigateToReschedule(id, history)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Timeline)
);
